export const trustBadges = {
  neasc: "Acreditado NEASC",
  xunta: "Autorizada Xunta de Galicia",
  trilingual: "Inglés 40-50% | ES | GL",
  ages: "3-12 años · Ratios reducidas"
};
